



















































import _ from 'lodash'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import EventBus from '@/plugins/EventBus'
import { onlyFloat } from '@/utils/common'
import { DataTablePagination } from '@/types/_'

@Component
export default class ModalEquipesProfissionalIncluir extends Vue {
  get getRegrasDeCalculoStore() {
    return getModule(RegrasDeCalculoStore, this.$store)
  }

  loadIntegrantesEquipe: boolean = false
  get loadingIntegrantesEquipe() { return this.loadIntegrantesEquipe }
  set loadingIntegrantesEquipe(value: boolean) { this.loadIntegrantesEquipe = value }

  get paginacaoIntegrantesEquipe() { return this.getRegrasDeCalculoStore.paginacaoIntegrantesEquipeMedica }

   async updatePaginationIntegrantesEquipe(pagination: DataTablePagination) {
     this.loadingIntegrantesEquipe = true
     this.regrasDeCalculoDebounced(pagination)
     this.loadingIntegrantesEquipe = false
  }

  regrasDeCalculoDebounced = _.debounce(param => this.getRegrasDeCalculoStore.getProfissionaisEquipeMedica(param), 700)

  loadAddRegraCalculoOperadora: boolean = false

  get showModalVisualizarEquipe() { return this.getRegrasDeCalculoStore.modal.integrantesEquipeProfissional }
  set showModalVisualizarEquipe(value: boolean) { this.getRegrasDeCalculoStore.setModal({ name: 'integrantesEquipeProfissional', value }) }

  get codigo() { return this.getRegrasDeCalculoStore.codigoFiltroProcedimento }
  set codigo(value: string) { this.getRegrasDeCalculoStore.setCodigoFiltroProcedimento(value) }

  get descricao() { return this.getRegrasDeCalculoStore.descricaoFiltroProcedimento }
  set descricao(value: string) { this.getRegrasDeCalculoStore.setDescricaoFiltroProcedimento(value) }

  get profissionaisEquipeMedica() { return this.getRegrasDeCalculoStore.profissionaisEquipeMedica }

  get selectedEquipeMedica() { return this.getRegrasDeCalculoStore.selectedEquipeMedica }
  set selectedEquipeMedica(value: number) { this.getRegrasDeCalculoStore.setSelectedEquipeMedica(value) }

    integrantesEquipeHeaders = [
        { text: 'Nome', value: 'profissionalNome', sortable: false },
        { text: 'Empresa médica', value: 'empresaMedicaNome', sortable: false },
        { text: 'Criado por', value: 'createdByNome', sortable: false },
      ]

  async vinculaEquipeMedica() {
    this.loadingIntegrantesEquipe = true
    const request = await this.getRegrasDeCalculoStore.postVinculoEquipeMedica()
    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${request.message} ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingIntegrantesEquipe = false
      return
    }
    EventBus.$emit('setSnackbar', {
      show: true,
      text: `Equipe vinculada com sucesso. ${String.fromCodePoint(0x1F642)}`,
      icon: 'done',
      color: '#2E7D32',
    })
    this.loadingIntegrantesEquipe = false

    await this.getRegrasDeCalculoStore.getEquipesProfissionalAll(this.paginacaoIntegrantesEquipe)
    this.showModalVisualizarEquipe = false
  }

  @Watch('showModalVisualizarEquipe')
  onChangeshowModalVisualizarEquipe(value: boolean) {
    if (!value) {
      this.getRegrasDeCalculoStore.setSelectedEquipeMedica('')
    } else {
      this.regrasDeCalculoDebounced(this.paginacaoIntegrantesEquipe)
    }
  }
}
